import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import uk from './locales/uk.json';
import { resolveInitialLocale } from './resolveLocale';

import { apiClient } from 'api/vektra/client';
import { syncPreferredLanguage } from 'api/vektra/language';

export const resources = {
  en: { translation: en },
  uk: { translation: uk }
} as const;

// Initial language is resolved from the same source as the theme config
// (persisted choice → browser locale → fallback). The active language is then
// driven by ConfigContext via `components/Locales.tsx`, which calls
// `i18n.changeLanguage` whenever the user switches in the header — so the
// resolution and the switcher share a single source of truth.
i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: 'uk',
  interpolation: { escapeValue: false },
  react: { useSuspense: false }
});

// VEK-92 — <html lang> follows the active language, so the document declares what it renders.
apiClient.setLanguage(i18n.language);
document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (next) => {
  apiClient.setLanguage(next);
  document.documentElement.lang = next;
  // NOTIF-07 (VEK-168) — a signed-in user's switch is recorded server-side; signed out, this is a no-op.
  syncPreferredLanguage(next);
});

export default i18n;
